import { render, staticRenderFns } from "./repairDetailModal.vue?vue&type=template&id=2878eb9e&scoped=true"
import script from "./repairDetailModal.vue?vue&type=script&lang=js"
export * from "./repairDetailModal.vue?vue&type=script&lang=js"
import style0 from "./repairDetailModal.vue?vue&type=style&index=0&id=2878eb9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878eb9e",
  null
  
)

export default component.exports